const jobCodeKey = 'jobCode'
const applyIdKey = 'applyID'
const expiredFlat = 'expired'
const vitaInfoTypeKey = 'vitaInfoTypeKey'
const interviewPlaceKey = 'getInterviewSitePlace'
const inviteKey = 'school_inviteKey'
const campusAmbassadorReferralCodeKey = 'campusAmbassadorReferralCodeKey'
const internalReferralCodeKey = 'internalReferralCodeKey'


export function getJobCode () {
  return sessionStorage.getItem(jobCodeKey)
}

export function setJobCode (jobCode) {
  return sessionStorage.setItem(jobCodeKey, jobCode)
}

export function removeJobCode () {
  return sessionStorage.removeItem(jobCodeKey)
}

export function getApplyId () {
  return sessionStorage.getItem(applyIdKey)
}

export function setApplyId (applyId) {
  return sessionStorage.setItem(applyIdKey, applyId)
}

export function removeApplyId () {
  return sessionStorage.removeItem(applyIdKey)
}

export function setIsExpired (expired) {
  return sessionStorage.setItem(expiredFlat, expired)
}

export function getExpired () {
  return sessionStorage.getItem(expiredFlat)
}

export function removeExpired () {
  return sessionStorage.removeItem(expiredFlat)
}

export function setVitaInfoType (type) {
  return sessionStorage.setItem(vitaInfoTypeKey, type)
}

export function getVitaInfoType () {
  return sessionStorage.getItem(vitaInfoTypeKey)
}

export function removeVitaInfoType () {
  return sessionStorage.removeItem(vitaInfoTypeKey)
}

export function setInterviewPlace (place) {
  return sessionStorage.setItem(interviewPlaceKey, place)
}

export function getInterviewSitePlace () {
  return sessionStorage.getItem(interviewPlaceKey)
}

export function removeInterviewPlace () {
  return sessionStorage.removeItem(interviewPlaceKey)
}

export function setIsInvite (expired) {
  return sessionStorage.setItem(inviteKey, expired)
}

export function getIsInvite () {
  return sessionStorage.getItem(inviteKey)
}

export function removeIsInvite () {
  return sessionStorage.removeItem(inviteKey)
}
export function setCampusAmbassadorReferralCode (value) {
  return sessionStorage.setItem(campusAmbassadorReferralCodeKey, value)
}

export function getCampusAmbassadorReferralCode () {
  return sessionStorage.getItem(campusAmbassadorReferralCodeKey)
}

export function removeCampusAmbassadorReferralCode () {
  return sessionStorage.removeItem(campusAmbassadorReferralCodeKey)
}

export function setInternalReferralCode (value) {
  return sessionStorage.setItem(internalReferralCodeKey, value)
}

export function getInternalReferralCode () {
  return sessionStorage.getItem(internalReferralCodeKey)
}

export function removeInternalReferralCode () {
  return sessionStorage.removeItem(internalReferralCodeKey)
}